import PartnerDashboard from "./PartnerDashboard";
export default PartnerDashboard;